module.exports = __webpack_public_path__ + "img/6E5CF433-26F8-4633-AC61-8545D41ABE77.222d0bad.png";